var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h_line"},[_c('div',{staticClass:"h_line_c"},[_c('ul',[_c('li',[_vm._v(" 河北甲壳虫建筑工程有限公司"),_c('span',[_vm._v(_vm._s(_vm.getCurDate()))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }